// extracted by mini-css-extract-plugin
export default {"container":"VideoPlayer__container___BW8fs"};